import footer_logo from "@/assets/images/footer_logo.png";
import { supabase } from "@/lib/supabase";
import { useState } from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      await supabase.from("newsletter_subscribers").upsert(
        { email: email.trim().toLowerCase(), status: "active", source: "footer" },
        { onConflict: "email" }
      );
    } finally {
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f0f1a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={footer_logo}
              alt="Gift Mantra"
              className="h-16 w-auto object-contain mb-4 brightness-200"
            />
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              Curated gifts for every occasion — thoughtfully designed, beautifully packaged, and made to be remembered.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/giftmantra51/" },
                { icon: "ri-facebook-line", href: "https://www.facebook.com/profile.php?id=61586415713879" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/+918180084435" },
                { icon: "ri-pinterest-line", href: "https://pinterest.com" },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-transparent hover:bg-gradient-to-r hover:from-[#5FA8D3] hover:to-[#F78FB3] hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/40 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", to: "/" },
                { label: "Products", to: "/products" },
                { label: "About Us", to: "/about" },
                { label: "Contact Us", to: "/contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-white/70 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/40 mb-4">Categories</h4>
            <ul className="space-y-3">
              {["Home Decor", "Lifestyle", "Gift Sets", "Custom Gifts", "Seasonal Specials", "Premium Collection"].map((cat) => (
                <li key={cat}>
                  <Link
                    to="/products"
                    className="text-sm text-white/70 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/40 mb-4">Stay Updated</h4>
            <p className="text-sm text-white/60 mb-4 leading-relaxed">
              Get exclusive offers and new arrivals straight to your inbox.
            </p>
            {subscribed ? (
              <div className="flex items-center gap-2 text-sm text-green-400">
                <i className="ri-check-line" />
                <span>You&apos;re subscribed!</span>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 min-w-0 px-4 py-2.5 rounded-full bg-white/10 border border-white/20 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#5FA8D3] transition-colors"
                  required
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-full bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] text-white text-sm font-medium whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                </button>
              </form>
            )}
            <p className="text-xs text-white/40 mt-3">No spam, unsubscribe anytime.</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">© 2025 Gift Mantra. All rights reserved.</p>
          <div className="flex items-center gap-4 text-xs text-white/40">
            <span>Privacy Policy</span>
            <span>·</span>
            <span>Terms of Use</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
